import { Directive, inject } from '@angular/core';
import { TranslationService } from '../../../services/translation.service';
import { TechnicalRedactionReviewable } from '../../../../shared/models/base/technical-redaction-reviewable';
import { WARNING_CONSTANTS } from '../../../../shared/constants/warning-constants';
import { Translatable } from '../../../../shared/models/base/translatable';
import { TranslationState } from '../../../../shared/enums/translation-state';
import { TrackUnsavedFieldBase } from '../track-unsaved-field-base';
import { Identifiable } from '../../../../shared/models/base/identifiable';

@Directive()
export abstract class EditTechnicalRedactionReviewableBase<
  T extends TechnicalRedactionReviewable & Translatable & Identifiable,
> extends TrackUnsavedFieldBase<T> {
  protected translationService = inject(TranslationService);

  public get translatableFieldsTerminalWarning(): string {
    if (!this.item) {
      return '';
    }
    if (this.translationService.defaultLanguageSelected()) {
      if (this.item.mainLanguageTerminalFieldsExportedForReview) {
        return WARNING_CONSTANTS.MAIN_LANGUAGE_EXPORTED_FOR_REVIEW;
      }
    } else {
      if (this.item.translationStateTerminal == TranslationState.TranslationPending) {
        return WARNING_CONSTANTS.TRANSLATION_PENDING;
      }
      if (this.item.translationStateTerminal == TranslationState.Translated) {
        return WARNING_CONSTANTS.ALREADY_TRANSLATED;
      }
    }
    return '';
  }

  public get translatableFieldsDocumentationWarning(): string {
    if (
      this.item &&
      this.item.mainLanguageDocumentationFieldsExportedForReview &&
      this.translationService.defaultLanguageSelected()
    ) {
      return WARNING_CONSTANTS.MAIN_LANGUAGE_EXPORTED_FOR_REVIEW;
    } else {
      return '';
    }
  }
}
